import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppointmentsService } from 'src/app/services/appointments.service';
import { AuthService } from 'src/app/services/auth.service';
import { ClientsService } from 'src/app/services/clients.service';
import { LanguageService } from 'src/app/services/language.service';
import { OrdersService } from 'src/app/services/orders.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-init',
  templateUrl: './init.component.html',
  styleUrl: './init.component.scss'
})
export class InitComponent {
  public companyName: string = environment.company;
  public processing: boolean=true;
  protected clientId:number;
  public userRoles: any|null = null;
  public clientInfo: any = {};
  protected currentProtocolId: number;
  public referralLink: string;
  public pendingPayments: Array<any> = [];
  public nextAppointments: Array<any> = [];
  public language:string = this.languageService.getLanguage();
  public environment = environment;

  constructor(private clientService: ClientsService,
      private activeRoute: ActivatedRoute,
      private authService:AuthService,
      private appointmentService: AppointmentsService,
      private languageService: LanguageService,
      private toastService: ToastrService,
      private orderService: OrdersService,
      @Inject(PLATFORM_ID) private platformId:Object) { };

  ngOnInit(): void {
    this.getUserRoles();
  }

  getUserRoles() {
    this.authService.getRoles().subscribe({
      next: response => { 
        this.userRoles = response.data;
        // console.log(this.userRoles)
        if (this.userRoles.is_user) {
          this.getCurrentUserData();
       } else {
        this.activeRoute.params.subscribe(params => {
          this.clientId = params.id;
        })
        this.consultClientData(this.clientId)
      }
      },
      error: error => {
        console.log("Error: ",error)
      }
    });
  }
  consultClientData(uid: number) {
    this.clientService.getUserById(uid).subscribe({
      next: response => {
        // console.log(response.data)
        this.clientInfo = response.data;
        this.currentProtocolId = response.data.dosage.id;
        // this.clientInfo.internal_protocol_id ? this.protocolForm.controls['internalProtocolId'].setValue(this.clientInfo.internal_protocol_id) : null;
      },
      complete: () => {
        this.processing = false;
      },
      error: error => {
        console.error(error)
      }
    });
  }
  getCurrentUserData() {
    this.clientService.getCurrentUser().subscribe({
      next: response => {
        // console.log(response);
        this.clientInfo = response.account;
        this.getReferralLink();
        localStorage.setItem('user', JSON.stringify(this.clientInfo))
        this.clientId = this.clientInfo.id;
        this.getPendingPayments();
        this.getNextAppointments();
      },
      complete: () => {this.processing = false; },
      error: error => {
        console.log("Consult User Error",error)
      }
    });
  }

  getNextAppointments() {
    this.appointmentService.getNextAppointments().subscribe({
      next: response => {
        // console.log(response.data)
        this.nextAppointments = response.appointments;
      },
      error: error => {
        console.error("Error fetching next appointments", error);
        this.toastService.error('Error fetching next appointments');
      }
    });
  }

  getReferralLink() {
    this.referralLink = `https://${environment.links.landing_base_link}${this.language}/r/${this.clientInfo?.username}`;
  }

  getPendingPayments() {
    this.orderService.getPaymentsPending().subscribe((res) => {
      this.pendingPayments = res.data;
    })
  }
}
